import { QueryOptions, useQuery } from 'react-query';
import { IGetTransactionsRequest } from '@app/api/types';
import { ITransaction } from '@features/workspace/types/banking';
import { IWithPagination } from '@features/workspace/types/generic';
import { getTransactions } from './requests';

export const useTransactions = (
  params: IGetTransactionsRequest,
  options?: QueryOptions<IWithPagination<ITransaction[]>>
) => {
  return useQuery<IWithPagination<ITransaction[]>>(
    // Query should be invalidated in case any of the parameters change
    [getTransactions.key, JSON.stringify(params)],
    () => getTransactions.executor(params),
    {
      retry: false,
      ...options,
    }
  );
};
